import { useRealtime } from '@/providers/realtimeContext';

/**
 * Interval for `refetchInterval`: off while the tenant realtime channel is
 * connected (changes arrive by push), `ms` otherwise.
 */
export function usePollingFallback(ms: number): number | false {
  const { isConnected } = useRealtime();
  return isConnected ? false : ms;
}
